import request from 'common/tools/network/request';
import { path } from 'common/tools/network/routing';

export function subscribeToNewsletterWithActito(email, campaignId) {
  return request(
    path('add_actito_email', {
      campaignId: campaignId,
      email: email
    }),
    {
      credentials: 'same-origin'
    }
  );
}
